import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Card from '@dashboard/components/Card';
import CardContent from '@dashboard/components/CardContent';
import CardHeader from '@dashboard/components/CardHeader';
import CardHeaderNav from '@dashboard/components/CardHeaderNav';
import CardHeaderTitle from '@dashboard/components/CardHeaderTitle';
import Plan from './scenes/Plan';
import Billing from './scenes/Billing';

const tabs = [
  {
    name: 'Plan',
    href: '/billing/plan',
    component: Plan,
  },
  {
    name: 'Billing',
    href: '/billing/billing',
    component: Billing,
  },
];

const BillingSettings = () => {
  return (
    <Card variant="root">
      <CardHeader variant="root">
        <CardHeaderTitle variant="root" className="w-full">
          Billing
        </CardHeaderTitle>

        <CardHeaderNav.Container tabs={tabs}>
          {({ currentTab }) =>
            tabs.map(tab => (
              <CardHeaderNav.Tab key={tab.name} tab={tab} current={currentTab.href === tab.href}>
                {tab.name}
              </CardHeaderNav.Tab>
            ))
          }
        </CardHeaderNav.Container>
      </CardHeader>

      <CardContent variant="root" className="mt-4 mb-32">
        <Switch>
          {tabs.map(tab => (
            <Route key={tab.href} path={tab.href} component={tab.component} />
          ))}
        </Switch>
      </CardContent>
    </Card>
  );
};

export default BillingSettings;
